import * as React from 'react';
import { PromotionQuestionsState } from './PromotionQuestionsState/PromotionQuestionsState';
import { ConfigState } from './ConfigState/ConfigState';
import { UniverseType } from 'src_common/common/universe';
import { CustomerTabState } from './CustomerTabState/CustomerTabState';
import { LandingPageState } from './LandingPageState/LandingPageState';
import { NotificationPageState } from './NotificationPageState/NotificationPageState';
import { TranslationPageState } from './TranslationPageState/TranslationPageState';
import { WebsocketV1 } from './websocketV1/WebsocketV1';
import { ModelsState } from './Models/ModelsState';
import { ReduxAction } from './ReduxAction';
import { AffordabilityExcludedState } from './AffordabilityExcludedState';
import { WithdrawalState } from './WithdrawalState';
import { AutomaticWithdrawalState } from 'src/AppState/AutomaticWithdrawalState';
import { UserLoginState } from './UserLoginState';
import { TopNavigationLinkState } from './TopNavigationLinkState/TopNavigationLinkState';
import { PagesState } from './PagesState/PagesState';
import { PromoCodesState } from './PromoCodesState/PromoCodesState';
import { LanguageState } from './LanguageState/LanguageState';
import { HeroWidgetState } from './HeroWidgetState/HeroWidgetState';
import { ModelsState as WebsocketModelsState } from 'src_common/common/websocket2/ModelsState';
import { CmsState } from './CmsState/CmsState';
import { LiveNotificationsState } from 'src/AppState/LiveNotificationsState/LiveNotificationsState';
import { MarketFiltersState } from 'src/AppState/MarketFiltersState/MarketFiltersState';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';
import { BankingTabState } from 'src/components/CustomersBar/CustomerTab/BankingTab/BankingTab.state';
import { CountriesState } from './CountriesState';
import { RouterBackoffice } from './RouterBackoffice';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { MarketsListState } from './MarketsListState';
import { ReduxRawState } from './Redux/utils/ReduxRawState';
import { ReduxBetslipSelectedLeg } from './Redux/ReduxBetslipSelectedLeg';
import { TagsState } from './TagsState';
import { ReduxBackofficeUserState } from './Redux/ReduxBackofficeUserState';
import { BettingConfigsState } from './BettingConfigsState';
import { ReduxBetslipState } from './Redux/ReduxBetslipState';
import { ReduxCustomerState } from './Redux/ReduxCustomerState';
import { ReduxReportState } from './Redux/ReduxReportState';
import { ReduxEventsOpened } from './Redux/ReduxEventsOpened';
import { WelcomeBonusState } from 'src/AppState/WelcomeBonusState/WelcomeBonusState';
import { ApiEvents } from './ApiEvents/ApiEvents';
import { Session } from 'src_common/sdk/session';
import { LocalStorageState } from './LocalStorageState/LocalStorageState';
import { SdkStaff } from 'src/AppState/sdk/staff';
import { EventStateActions } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/EventActionsState/EventActionsState';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { TypeId } from 'src_common/common/websocket2/type';
import { SportsbookState } from 'src/domains/sportsbook/trading/state/SportsbookState';
import { ReduxLoginState } from 'src/AppState/Redux/ReduxLoginState';
import { EventsTabState } from 'src/AppState/EventsTabState';
import { FraudAndComplianceState } from 'src/AppState/FraudAndComplianceState/FraudAndComplianceState';
import { AppEnvParamsBrowser } from 'src/utils/appEnvParams';
import { TrpcClient } from './TrpcClient';
import { getUniverseModule } from 'src/domains/common/universes';
import type { UniverseModuleType } from 'src/domains/common/universes.type';
import { Common } from './Common';
import { NotificationsStateNew } from './NotificationsStateNew/NotificationState';
import { PagesStateV2 } from './PagesState/PagesStateV2';
import { PermissionGrantsState } from './PermissionGrants/PermissionGrants.state';

export interface RouterType {
    aliases: Record<string, string>;
    defaultUrl: string;
    onAlias: (route: string, parameters: Array<string>, x: boolean) => void;
    onChange: (route: string, parameters: Array<string>) => void;
    parameters: Record<string, string>;
    route: unknown;
    routes: Record<string, string>;
    urls: Record<string, string>;
}
export class AppState {
    /**
     * @deprecated - Please use common.appEnvParams
     */
    public readonly appEnvParams: AppEnvParamsBrowser;
    public readonly universeModule: UniverseModuleType;
    /**
     * @deprecated - Please use common.session
     */
    public readonly session: Session;
    /**
     * @deprecated - Please use common.trpcClient
     */
    public readonly trpcClient: TrpcClient;
    public readonly reduxStore: ReduxRawState;
    public readonly reduxAction: ReduxAction;
    public readonly languageState: LanguageState;
    public readonly userLoginState: UserLoginState;
    public readonly promotionQuestionsState: PromotionQuestionsState;
    public readonly landingPageState: LandingPageState;
    public readonly pagesState: PagesState;
    public readonly pagesStateV2: PagesStateV2;
    public readonly notificationPageState: NotificationPageState;
    public readonly translationPageState: TranslationPageState;
    public readonly liveNotificationsState: LiveNotificationsState;
    public readonly topNavigationLinkState: TopNavigationLinkState;
    public readonly heroWidgetState: HeroWidgetState;
    public readonly promoCodesState: PromoCodesState;
    public readonly welcomeBonusState: WelcomeBonusState;
    public readonly customerTabState: CustomerTabState;
    /**
     * @deprecated - Please use ConfigState.get(common)
     */
    public readonly configState: ConfigState;
    public readonly websocketV1: WebsocketV1;
    public readonly models: ModelsState;
    public readonly permissionGrantsState: PermissionGrantsState;
    public readonly affordabilityExcludedState: AffordabilityExcludedState;
    public readonly withdrawalState: WithdrawalState;
    public readonly automaticWithdrawalState: AutomaticWithdrawalState;
    public readonly cmsState: CmsState;
    public readonly countriesState: CountriesState;
    public readonly marketsListState: MarketsListState;
    public readonly reduxBetslipSelectedLeg: ReduxBetslipSelectedLeg;
    public readonly tagsState: TagsState;
    public readonly reduxBackofficeUserState: ReduxBackofficeUserState;
    public readonly bettingConfigsState: BettingConfigsState;
    public readonly reduxBetslipState: ReduxBetslipState;
    public readonly reduxCustomerState: ReduxCustomerState;
    public readonly reduxReportState: ReduxReportState;
    public readonly reduxEventsOpened: ReduxEventsOpened;
    public readonly sdkStaff: SdkStaff;
    public readonly apiEvents: ApiEvents;
    public readonly eventStateActions: EventStateActions;
    public readonly sportsbookState: SportsbookState;
    public readonly reduxLoginState: ReduxLoginState;
    public readonly eventsTabState: EventsTabState;
    public readonly fraudAndComplianceState: FraudAndComplianceState;

    /**
     * @deprecated - please use routerBackoffice
     */
    public router: RouterType;

    public routerBackoffice: RouterBackoffice;

    /**
     * @deprecated - please use sdkStaff.models
     */
    public readonly websocketV2: WebsocketModelsState;
    public readonly localStorageState: LocalStorageState;
    public readonly marketFiltersState: AutoMap<string, MarketFiltersState>;
    public readonly bankingTabState: AutoMap<number, BankingTabState>;
    public appCasinoState: AppCasinoState;

    public notificationsStateNew: NotificationsStateNew;

    public constructor(
        public readonly common: Common,
        reduxStore: ReduxRawState,
        router: RouterType
    ) {
        this.appEnvParams = common.appEnvParams;
        this.universeModule = getUniverseModule(common);
        this.session = common.session;
        this.trpcClient = common.trpcClient;
        this.reduxStore = reduxStore;
        this.reduxBetslipState = new ReduxBetslipState(reduxStore);
        this.reduxCustomerState = new ReduxCustomerState(reduxStore);
        this.reduxAction = new ReduxAction(reduxStore, this.reduxBetslipState, this.reduxCustomerState);
        this.userLoginState = new UserLoginState();
        this.languageState = new LanguageState();
        this.router = router;

        this.configState = ConfigState.get(common);

        this.sdkStaff = new SdkStaff(
            common.session,
            {
                socketJoinSport: false,
                reduxStore,
            },
            this.appEnvParams,
            this.trpcClient
        );
        this.websocketV2 = this.sdkStaff.models;
        this.reduxReportState = new ReduxReportState(reduxStore, this.configState);

        this.promotionQuestionsState = new PromotionQuestionsState();
        this.notificationPageState = new NotificationPageState();
        this.translationPageState = new TranslationPageState();
        this.liveNotificationsState = new LiveNotificationsState(this.trpcClient);
        this.landingPageState = new LandingPageState();
        this.pagesState = new PagesState(common.appEnvParams.universe_theme);
        this.pagesStateV2 = new PagesStateV2(common.appEnvParams.universe_theme);
        this.topNavigationLinkState = new TopNavigationLinkState(common.appEnvParams.universe_theme);
        this.heroWidgetState = new HeroWidgetState();
        this.promoCodesState = new PromoCodesState();
        this.welcomeBonusState = new WelcomeBonusState(this.promoCodesState, common.appEnvParams.universe_theme);
        this.customerTabState = new CustomerTabState(this.router);
        this.cmsState = new CmsState(this.configState, this.websocketV2, this.sdkStaff, this.trpcClient);

        this.routerBackoffice = new RouterBackoffice(reduxStore, this.websocketV2);

        this.websocketV1 = WebsocketV1.get(common);
        this.models = new ModelsState(this.websocketV1, this.sdkStaff, this.trpcClient);
        this.permissionGrantsState = new PermissionGrantsState(reduxStore);

        this.withdrawalState = new WithdrawalState(
            this.trpcClient,
            this.userLoginState,
            this.configState.config.usePaymentFormForUniverse,
            this.sdkStaff,
            this.common
        );
        this.affordabilityExcludedState = new AffordabilityExcludedState(this.userLoginState, this.sdkStaff);
        this.automaticWithdrawalState = new AutomaticWithdrawalState(
            this.sdkStaff,
            this.trpcClient,
            this.configState.config.usePaymentFormForUniverse
        );
        this.marketFiltersState = new AutoMap(
            (sportName: string) => new MarketFiltersState(this.websocketV2, sportName)
        );
        this.bankingTabState = new AutoMap(
            (customerId: number) => new BankingTabState(customerId, this.common, this.sdkStaff, this.models)
        );
        this.countriesState = new CountriesState();
        this.marketsListState = new MarketsListState();
        this.reduxBetslipSelectedLeg = new ReduxBetslipSelectedLeg(reduxStore);
        this.tagsState = new TagsState();
        this.reduxBackofficeUserState = new ReduxBackofficeUserState(reduxStore);
        this.bettingConfigsState = new BettingConfigsState(this.trpcClient);
        this.reduxEventsOpened = new ReduxEventsOpened(reduxStore);
        this.apiEvents = new ApiEvents(this.sdkStaff);
        this.localStorageState = new LocalStorageState(this.configState);

        // temp implementation in appState moze to src/components/Events/EventDetails
        this.eventStateActions = new EventStateActions(this.sdkStaff);

        this.sportsbookState = new SportsbookState(this.localStorageState);

        this.reduxLoginState = new ReduxLoginState(reduxStore);
        this.eventsTabState = new EventsTabState(this.websocketV2, this.routerBackoffice, this.sdkStaff);
        this.fraudAndComplianceState = new FraudAndComplianceState(
            this.configState,
            this.automaticWithdrawalState,
            this.withdrawalState,
            this.trpcClient
        );

        this.appCasinoState = new AppCasinoState(this.common, this.routerBackoffice);

        this.notificationsStateNew = new NotificationsStateNew();
    }

    public static async create(common: Common, reduxStore: ReduxRawState, router: RouterType): Promise<AppState> {
        return new AppState(common, reduxStore, router);
    }

    public get isProdMode(): boolean {
        return this.appEnvParams.isProdMode;
    }

    /**
     * @deprecated - use the configuration file for universes
     */
    public get universe_theme(): UniverseType {
        return this.appEnvParams.universe_theme;
    }

    public get universe_api(): UniverseType {
        return this.appEnvParams.universe_api;
    }

    public getSelection(marketId: TypeId.MarketId, selectionId: number): SelectionModel | null {
        return this.websocketV2.getSelectionAndLoad(marketId, selectionId);
    }
}

const AppContext = React.createContext<AppState | null>(null);

export const Provider = AppContext.Provider;

/**
 * @deprecated - Get rid of this reference. As a last resort, you can even use the global variable $appState.
 */

export class AppStateComponent<PropsType = {}, StateType = {}> extends React.Component<PropsType, StateType> {
    public static contextType = AppContext;

    public get appState(): AppState {
        //Fix for "any" type
        //@ts-expect-error
        return this.context;
    }
}

export const useAppStateContext = (): AppState => {
    const appState: AppState | null = React.useContext(AppContext);

    if (appState === null) {
        throw Error('App state error');
    }

    return appState;
};
